import styled from 'styled-components';

interface StyledSplashLoaderProps {
  $bgColor: string;
}

export const StyledSplashLoader = styled.div<StyledSplashLoaderProps>`
  width: 100%;
  height: calc(100vh);
  position: absolute;
  top: 0;
  left: 0;
  background: ${({ $bgColor }) => $bgColor};
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 1000000;
`;
